module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "hero-wrapper",
    class: [_vm.fill]
  }, [(!_vm.isMobile()) ? _c('div', {
    staticClass: "iframe-wrapper"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.video.source,
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMobile()) ? _c('div', {
    staticClass: "background",
    style: ({
      'backgroundImage': 'url(' + _vm.video.poster + ')'
    })
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-text"
  }, [_c('div', {}, [_c('h2', [_vm._v("Learn with Hato")]), _vm._v(" "), _c('h3', [_vm._v("Learn through play and take your pick of these creative workshops – curated by us.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d86dd1c","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroVideo.vue
// module id = 210
// module chunks = 1